// extracted by mini-css-extract-plugin
module.exports = {"root":"LogoLink_root__DJvFO","logo":"LogoLink_logo__UNF_R"};